/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    ProvisioningDeviceResponse,
    ProvisioningDeviceResponseFromJSON,
    ProvisioningDeviceResponseToJSON,
    ProvisioningDevicesResponse,
    ProvisioningDevicesResponseFromJSON,
    ProvisioningDevicesResponseToJSON,
} from '../models';

export interface CreateDeviceProvisioningExportJobRequest {
    filterMacAddress?: string | null;
    filterSerialNumber?: string | null;
    filterDeviceTypeId?: string | null;
    filterStbGroupId?: string | null;
}

export interface DeleteProvisioningDeviceRequest {
    macAddress: string;
}

export interface ReadProvisioningDeviceRequest {
    macAddress: string;
}

export interface ReadProvisioningDevicesRequest {
    filterDeviceTypeId?: string | null;
    filterStbGroupId?: string | null;
    filterSerialNumber?: string | null;
    filterMacAddress?: string | null;
    offset?: number | null;
    limit?: number | null;
}

/**
 * 
 */
export class ProvisioningDevicesApi extends runtime.BaseAPI {

    /**
     * Create provisioning devices export job.
     */
    async createDeviceProvisioningExportJobRaw(requestParameters: CreateDeviceProvisioningExportJobRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filterMacAddress !== undefined) {
            queryParameters['filterMacAddress'] = requestParameters.filterMacAddress;
        }

        if (requestParameters.filterSerialNumber !== undefined) {
            queryParameters['filterSerialNumber'] = requestParameters.filterSerialNumber;
        }

        if (requestParameters.filterDeviceTypeId !== undefined) {
            queryParameters['filterDeviceTypeId'] = requestParameters.filterDeviceTypeId;
        }

        if (requestParameters.filterStbGroupId !== undefined) {
            queryParameters['filterStbGroupId'] = requestParameters.filterStbGroupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/jobExports/provisioningDevices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create provisioning devices export job.
     */
    async createDeviceProvisioningExportJob(requestParameters: CreateDeviceProvisioningExportJobRequest = {}, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createDeviceProvisioningExportJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete provisioning device by MAC address.
     */
    async deleteProvisioningDeviceRaw(requestParameters: DeleteProvisioningDeviceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.macAddress === null || requestParameters.macAddress === undefined) {
            throw new runtime.RequiredError('macAddress','Required parameter requestParameters.macAddress was null or undefined when calling deleteProvisioningDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/provisioningDevices/{macAddress}`.replace(`{${"macAddress"}}`, encodeURIComponent(String(requestParameters.macAddress))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete provisioning device by MAC address.
     */
    async deleteProvisioningDevice(requestParameters: DeleteProvisioningDeviceRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteProvisioningDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Read provisioning device by MAC address.
     */
    async readProvisioningDeviceRaw(requestParameters: ReadProvisioningDeviceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProvisioningDeviceResponse>> {
        if (requestParameters.macAddress === null || requestParameters.macAddress === undefined) {
            throw new runtime.RequiredError('macAddress','Required parameter requestParameters.macAddress was null or undefined when calling readProvisioningDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/provisioningDevices/{macAddress}`.replace(`{${"macAddress"}}`, encodeURIComponent(String(requestParameters.macAddress))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProvisioningDeviceResponseFromJSON(jsonValue));
    }

    /**
     * Read provisioning device by MAC address.
     */
    async readProvisioningDevice(requestParameters: ReadProvisioningDeviceRequest, initOverrides?: RequestInit): Promise<ProvisioningDeviceResponse> {
        const response = await this.readProvisioningDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read provisioning devices.
     */
    async readProvisioningDevicesRaw(requestParameters: ReadProvisioningDevicesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProvisioningDevicesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filterDeviceTypeId !== undefined) {
            queryParameters['filterDeviceTypeId'] = requestParameters.filterDeviceTypeId;
        }

        if (requestParameters.filterStbGroupId !== undefined) {
            queryParameters['filterStbGroupId'] = requestParameters.filterStbGroupId;
        }

        if (requestParameters.filterSerialNumber !== undefined) {
            queryParameters['filterSerialNumber'] = requestParameters.filterSerialNumber;
        }

        if (requestParameters.filterMacAddress !== undefined) {
            queryParameters['filterMacAddress'] = requestParameters.filterMacAddress;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/provisioningDevices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProvisioningDevicesResponseFromJSON(jsonValue));
    }

    /**
     * Read provisioning devices.
     */
    async readProvisioningDevices(requestParameters: ReadProvisioningDevicesRequest = {}, initOverrides?: RequestInit): Promise<ProvisioningDevicesResponse> {
        const response = await this.readProvisioningDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read provisioning devices export.
     */
    async readProvisioningDevicesExportCsvRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/provisioningDevicesExport.csv`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Read provisioning devices export.
     */
    async readProvisioningDevicesExportCsv(initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.readProvisioningDevicesExportCsvRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read provisioning devices export.
     */
    async readProvisioningDevicesExportCsvGzRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/provisioningDevicesExport.csv.gz`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Read provisioning devices export.
     */
    async readProvisioningDevicesExportCsvGz(initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.readProvisioningDevicesExportCsvGzRaw(initOverrides);
        return await response.value();
    }

}
